/* global axios */
const BASE = '/api/v1/profile/mfa';

export const getMfaStatus = () => axios.get(BASE);

export const setupMfa = currentPassword =>
  axios.post(`${BASE}/setup`, { current_password: currentPassword });

export const enableMfa = otpAttempt =>
  axios.post(`${BASE}/enable`, { otp_attempt: otpAttempt });

export const disableMfa = currentPassword =>
  axios.delete(BASE, { data: { current_password: currentPassword } });
